module.exports = __webpack_public_path__ + "static/media/mikko-kojo.00742400.jpg";